import React, { useState, useEffect } from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { ListSubheader, MenuItem, TextField, Tooltip } from '@material-ui/core';
import { getAllCustomerToNotice } from './handler/NoticeTicketHandler';
import { I18n } from 'aws-amplify';
import FormInput from '../common/form/input';
import { isInputFormValue, submitOnchangeForm } from './handler/HelpdeskCreateTicketHandler';
import { getProjectInternalLabel } from './handler/QaTicketHandler';
import { useRecoilState, useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';

import _, { cloneDeep } from 'lodash';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { panelInitDataAtom } from '@/state/atom/panelAtom';
import { getFormFromFormListById } from './handler/TicketHandler';

export default function NoticeTicket(props) {
    const methodNoticeList = [
        { name: '特定カスタマー', value: 0 },
        { name: '複数カスタマー', value: 1 }
    ];

    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [baseProject, setBaseProject] = useState([]);
    const [guestCustomerProject, setGuestCustomerProject] = useState([]);
    const [isOpenSelectCustomer, setIsOpenSelectCustomer] = useState(false);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [sortNoticeCustomerList, setSortNoticeCustomerList] = useState([]);
    
    const argsAll = {
        ...props,
        baseProject,
        setBaseProject,
        guestCustomerProject,
        setGuestCustomerProject,
        typeOfTicket: Constant.TICKET_TYPE.NOTICE
    };

    const isDeskOnPublicOffSendDraft = Utils.isPrivateDesk(projectInuseDetail) && argsAll?.isDraft

    // Update panelInitDataAtom
    useEffect(() => {
        let newArgsAll = cloneDeep(argsAll);
        delete newArgsAll.panelInitData;
        delete newArgsAll.currentPanelInitData;
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'argsAllCreateTicketNotice',
            newArgsAll
        );
    }, [props.methodNotice, props.noticeCustomer, props.noticeCustomerList]);

    const handleOnChangeMethodNotice = event => {
        if (event.target.value || event.target.value === 0) {
            if (event.target.value === props.methodNotice) {
                return;
            }
            props.setMethodNotice(event.target.value);
            props.setNoticeCustomer('');
            props.setIsEdited(true);
            props.clearErrors('noticeCustomer');
        }
    };

    const isDisplayOption = option => {
        let result = false;
        switch (option) {
            case 'ゲストカスタマーユーザー':
                result =
                    (Utils.isPublicDesk(projectInuseDetail) &&
                        !Utils.isEmptyArray(props.listCustomerUser)) ||
                    (
                        isDeskOnPublicOffSendDraft &&
                        (
                            !Utils.isEmptyArray(props.listCustomerUser) ||
                            props?.detailTicket?.customer === Constant.NOTICE_GROUP_CUSTOMER.ALL_GUEST_CUSTOMER_USER
                        )
                    );
                break;
            case '組織内プロジェクト':
                result =
                    !Utils.isProjectGuestDesk(projectInuseDetail) &&
                    !Utils.isEmptyArray(props.generalProjectList);
                break;
            case '組織内ユーザー':
                result =
                    !Utils.isProjectGuestDesk(projectInuseDetail) &&
                    !Utils.isEmptyArray(props.baseProjectUserList);
                break;
            case 'カスタマープロジェクト':
                result =
                    (Utils.isPublicDesk(projectInuseDetail) &&
                        !Utils.isEmptyArray(props.listExternalCustomerProject)) ||
                    (
                        isDeskOnPublicOffSendDraft &&
                        (
                            !Utils.isEmptyArray(props.listExternalCustomerProject) ||
                            props?.detailTicket?.customer === Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT
                        )
                    );
                break;
            default:
                result = true;
                break;
        }
        return result;
    };

    const filterListMultiCustomerOptions = () => {
        const newLisMultiOption = props.listOptionsNoticeMultiCustomer.filter(option => {
            const isDisplay = isDisplayOption(option.name);
            return isDisplay;
        });
        return newLisMultiOption.map(option => ({
            ...option,
            isDisable: isDeskOnPublicOffSendDraft &&
                [
                    Constant.NOTICE_GROUP_CUSTOMER.ALL_GUEST_CUSTOMER_USER,
                    Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT,
                ].includes(option.id)
        }));
    };

    const isInitDataTicketDraft = props.isDraftMode && !props.currentPanelInitData?.argsAll;


    useEffect(() => {
        let userDetail = props.userDetail;
        props.registerCreateTicket('noticeCustomer');
        props.registerCreateTicket('projectTargetObjList');
        props.setIsLoadingInitData(true);
        getAllCustomerToNotice(
            props?.API,
            props.corporationDetail,
            props.projectInuseDetail,
            props.userDetail,
            props
        )
            .then(async result => {
                let projectListClone = [
                    ...result.allGeneralProject,
                    ...result.allExternalCustomerProject,
                    ...result.allUserInBaseProject,
                    ...result.allCustomerUser
                ];

                // Update state for group notice
                props.setGeneralProjectList(result.allGeneralProject);
                props.setBaseProjectUserList(result.allUserInBaseProject);

                props.setNoticeCustomerList(projectListClone);
                props.setListCustomerUser([...result.allCustomerUser]);
                props.setListExternalCustomerProject([...result.allExternalCustomerProject]);
                setGuestCustomerProject([...result.guestCustomerProject]);
                setBaseProject([...result.projectBase]);

                if (isInitDataTicketDraft) {
                    return props.setIsLoadingInitData(false);
                }

                let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                let lastFormOfProject = workLastForm[projectInuseDetail.id];
                let switchFormId = props?.selectedForm ? props.selectedForm : '';

                if (lastFormOfProject) {
                    let lastFormNotiOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_NOTICE];
                    if (!Utils.isEmptyObject(lastFormNotiOfProject)) {
                        // Validate Form
                        let selectedFormDetail = await getFormFromFormListById(
                            lastFormNotiOfProject?.formId
                        );
                        let isLastFormNotValid = Utils.isEmptyObject(selectedFormDetail) || !selectedFormDetail.usingProjects.includes(projectInuseDetail.id);
                    
                        if (!isLastFormNotValid && !switchFormId) {
                            switchFormId = lastFormNotiOfProject?.formId;
                        }
                    }
                }
                if (switchFormId) {
                    let e = {
                        target: {
                            value: switchFormId
                        }
                    }
                    await handleOnchangeFormNotice(e, {
                        ...argsAll,
                        selectedForm: ''
                    })
                }

                props.setIsLoadingInitData(false);
            })
            .catch(error => {
                props.setIsLoadingInitData(false);
            });
    }, [props?.projectInuseDetail]); // re-query when change prj type

    const generateProjectTargetList = listProject => {
        let listProjectTargetList = [];
        listProject.forEach(project => {
            listProjectTargetList.push({
                id: project.id,
                corporationId: project.affiliationOrganization
            });
        });
        return listProjectTargetList;
    };

    const getValueToProjectTargetList = customer => {
        const prefixOfCustomer = Utils.getPrefixOfId(customer);
        let listProjectTargetList = [];
        if (prefixOfCustomer === 'user') {
            let receiverNotice = props.listCustomerUser?.find(user => {
                return user.id === customer;
            });
            // customer is customer user
            if (!Utils.isEmptyObject(receiverNotice)) {
                listProjectTargetList = [
                    {
                        id: guestCustomerProject[0]?.id,
                        corporationId: guestCustomerProject[0]?.affiliationOrganization
                    }
                ];
            } else {
                // customer is user in base project
                listProjectTargetList = [
                    {
                        id: baseProject[0]?.id,
                        corporationId: baseProject[0]?.affiliationOrganization
                    }
                ];
            }
        }

        if (prefixOfCustomer === 'project') {
            let projectReceiveNotice = props.listExternalCustomerProject?.find(project => {
                return project.id === customer;
            });
            // customer is external customer project
            if (!Utils.isEmptyObject(projectReceiveNotice)) {
                listProjectTargetList = [
                    {
                        id: customer,
                        corporationId: projectReceiveNotice.affiliationOrganization
                    }
                ];
            } else {
                // customer is general project
                listProjectTargetList = [
                    {
                        id: customer,
                        corporationId: props.corporationDetail.id
                    }
                ];
            }
        }
        return listProjectTargetList;
    };

    useEffect(() => {
        if (!props.noticeCustomer) return;

        props.registerCreateTicket('noticeCustomer');
        props.setValueCreateTicket('noticeCustomer', props.noticeCustomer);

        switch (props.noticeCustomer) {
            case 'AllCustomerProject':
                props.setValueCreateTicket(
                    'projectTargetObjList',
                    generateProjectTargetList(props.listExternalCustomerProject)
                );
                break;
            case 'AllGuestCustomerUser':
                props.setValueCreateTicket(
                    'projectTargetObjList',
                    generateProjectTargetList(guestCustomerProject)
                );
                break;
            case 'AllGeneralProject':
                props.setValueCreateTicket('projectTargetObjList', []);
                break;
            case 'AllUserInBaseProject':
                props.setValueCreateTicket(
                    'projectTargetObjList',
                    generateProjectTargetList(baseProject)
                );
                break;
            default:
                props.setValueCreateTicket(
                    'projectTargetObjList',
                    getValueToProjectTargetList(props.noticeCustomer)
                );
                break;
        }
        props.clearErrors('noticeCustomer');
    }, [
        props.methodNotice,
        props.noticeCustomer,
        props.generalProjectList,
        props.baseProjectUserList,
        props.listCustomerUser,
        props.listExternalCustomerProject,
        props.noticeCustomerList,
        guestCustomerProject,
        baseProject
    ]);

    const handleOnchangeFormNotice = async (e, argsAll) => {
        let currentSelectedForm = '';
        if (e.target.value) {
            currentSelectedForm = e.target.value;
        } else if (e.target.dataset.value) {
            currentSelectedForm = e.target.dataset.value;
        }

        if (!currentSelectedForm || currentSelectedForm === argsAll.selectedForm) {
            return;
        }

        if (isInputFormValue(argsAll)) {
            argsAll.setIsConfirmChangeForm(true);
            argsAll.setSelectedFormChange(currentSelectedForm);
        } else {
            submitOnchangeForm(currentSelectedForm, argsAll);
        }

        argsAll.setIsOpenSelectForm(false);
    };

    useEffect(() => {
        setSortNoticeCustomerList(_.orderBy(
            props.noticeCustomerList,
            ['label', 'name'],
            ['asc', 'asc']
        ))
    }, [props.noticeCustomerList]);

    return (
        <div className='helpdesk-create-notice'>
            <div className="form-addTicket">
                <label className="form-addTicket-label">お知らせ方法</label>
                <div className="form-addTicket-input" data-cy="qa-ticket-select-form">
                    <TextField
                        className="form-control form-control--wrap form-control--hg40"
                        select
                        variant="outlined"
                        name="selectedForm"
                        required
                        value={props.methodNotice}
                        onClick={handleOnChangeMethodNotice}
                        errorlist={props.errorCreateTicket}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        disabled={!Utils.isEmptyString(props.detailTicket?.deletedAt)}
                    >
                        {methodNoticeList?.map(item => {
                            return <MenuItem value={item.value}>{item.name}</MenuItem>;
                        })}
                    </TextField>
                </div>
            </div>
            <div className="form-addTicket">
                <label className="form-addTicket-label">お知らせ先</label>
                <div className="form-addTicket-input" data-cy="qa-ticket-select-form">
                    {props.methodNotice === Constant.NOTICE_METHOD.SINGLE ? (
                        <FormInput
                            className="form-control form-control--wrap form-control--hg40"
                            select
                            variant="outlined"
                            name="noticeCustomer"
                            value={props.noticeCustomer ? props.noticeCustomer : ''}
                            defaultValue={props.noticeCustomer ? props.noticeCustomer : ''}
                            require
                            SelectProps={{
                                value: props.noticeCustomer ? props.noticeCustomer : '',
                                open: isOpenSelectCustomer,
                                onClose: e => setIsOpenSelectCustomer(false),
                                onOpen: e => setIsOpenSelectCustomer(true),
                                MenuProps: {
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null,
                                    className: 'selectDrop'
                                }
                            }}
                            errorlist={props.errorCreateTicket}
                            disabled={!Utils.isEmptyString(props.detailTicket?.deletedAt)}
                        >
                            {Utils.isEmptyArray(props.noticeCustomerList) && (
                                <MenuItem style={{ display: 'none' }}></MenuItem>
                            )}
                            {/* internalHelpDeskList */}
                            {isDisplayOption('組織内プロジェクト') && (
                                <ListSubheader
                                    className="fontw-bold select-item"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={e => e.stopPropagation()}
                                >
                                    {I18n.get('USER04BTN007')}
                                </ListSubheader>
                            )}
                            {isDisplayOption('組織内プロジェクト') &&
                                sortNoticeCustomerList?.map(customer => {
                                    if (customer.groupLabel === '組織内プロジェクト') {
                                        return (
                                            <MenuItem
                                                key={customer.id}
                                                value={customer.id}
                                                onClick={e => {
                                                    props.setNoticeCustomer(customer.id);
                                                    props.setIsEdited(true);
                                                    props.clearErrors('noticeCustomer');
                                                }}
                                            >
                                                {getProjectInternalLabel(customer)}
                                            </MenuItem>
                                        );
                                    }
                                })}
                            {isDisplayOption('カスタマープロジェクト') && (
                                <ListSubheader
                                    className="fontw-bold select-item"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={e => e.stopPropagation()}
                                >
                                    {I18n.get('USER04BTN031')}
                                </ListSubheader>
                            )}
                            {isDisplayOption('カスタマープロジェクト') &&
                                sortNoticeCustomerList?.map(customer => {
                                    if (customer.groupLabel === 'カスタマープロジェクト') {
                                        return (
                                            <MenuItem
                                                style={isDeskOnPublicOffSendDraft
                                                    ? { opacity: 0.8, color: '#a9a9a9', cursor: 'default' } : undefined
                                                }
                                                key={customer.id}
                                                value={customer.id}
                                                onClick={e => {
                                                    if (isDeskOnPublicOffSendDraft) return;
                                                    props.setNoticeCustomer(customer.id);
                                                    props.setIsEdited(true);
                                                    props.clearErrors('noticeCustomer');
                                                }}
                                            >
                                                {customer.label}
                                            </MenuItem>
                                        );
                                    }
                                })}
                            {isDisplayOption('組織内ユーザー') && (
                                <ListSubheader
                                    className="fontw-bold select-item"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={e => e.stopPropagation()}
                                >
                                    {I18n.get('USER04BTN034')}
                                </ListSubheader>
                            )}
                            {isDisplayOption('組織内ユーザー') &&
                                sortNoticeCustomerList?.map(customer => {
                                    if (customer.groupLabel === '組織内ユーザー') {
                                        return (
                                            <MenuItem
                                                key={customer.id}
                                                value={customer.id}
                                                onClick={e => {
                                                    props.setNoticeCustomer(customer.id);
                                                    props.setIsEdited(true);
                                                    props.clearErrors('noticeCustomer');
                                                }}
                                            >
                                                {customer.label}
                                            </MenuItem>
                                        );
                                    }
                                })}
                            {isDisplayOption('ゲストカスタマーユーザー') && (
                                <ListSubheader
                                    className="fontw-bold select-item"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={e => e.stopPropagation()}
                                >
                                    {I18n.get('USER04BTN033')}
                                </ListSubheader>
                            )}
                            {isDisplayOption('ゲストカスタマーユーザー') &&
                                sortNoticeCustomerList?.map(customer => {
                                    if (customer.groupLabel === 'ゲストカスタマーユーザー') {
                                        return (
                                            <MenuItem
                                                style={isDeskOnPublicOffSendDraft
                                                    ? { opacity: 0.8, color: '#a9a9a9', cursor: 'default' } : undefined
                                                }
                                                key={customer.id}
                                                value={customer.id}
                                                onClick={e => {
                                                    if (isDeskOnPublicOffSendDraft) return;
                                                    props.setNoticeCustomer(customer.id);
                                                    props.setIsEdited(true);
                                                    props.clearErrors('noticeCustomer');
                                                }}
                                            >
                                                {customer.label}
                                            </MenuItem>
                                        );
                                    }
                                })}
                        </FormInput>
                    ) : (
                        <TextField
                            className="form-control form-control--wrap form-control--hg40"
                            select
                            variant="outlined"
                            name="noticeCustomer"
                            value={props.noticeCustomer ? props.noticeCustomer : ''}
                            defaultValue={props.noticeCustomer ? props.noticeCustomer : ''}
                            required
                            onChange={e => {
                                const selectedCustomer = e.target.value;
                                if (isDeskOnPublicOffSendDraft &&
                                    [
                                        Constant.NOTICE_ALL_CUSTOMER.ALL_CUSTOMER_PROJECT,
                                        Constant.NOTICE_ALL_CUSTOMER.ALL_GUEST_CUSTOMER_USER,
                                    ].includes(selectedCustomer)
                                ) return;
                                props.setNoticeCustomer(e.target.value);
                                props.setIsEdited(true);
                                props.clearErrors('noticeCustomer');
                            }}
                            errorlist={props.errorCreateTicket}
                            SelectProps={{
                                value: props.noticeCustomer ? props.noticeCustomer : '',
                                MenuProps: {
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null,
                                    className: 'selectDrop'
                                }
                            }}
                            error={
                                props.errorCreateTicket['noticeCustomer']?.message ? true : false
                            }
                            helperText={
                                props.errorCreateTicket['noticeCustomer']?.message
                                    ? props.errorCreateTicket['noticeCustomer']?.message
                                    : ''
                            }
                            disabled={!Utils.isEmptyString(props.detailTicket?.deletedAt)}
                        >
                            {Utils.isEmptyArray(props.listOptionsNoticeMultiCustomer) && (
                                <MenuItem style={{ display: 'none' }}></MenuItem>
                            )}

                            {!Utils.isEmptyArray(props.listOptionsNoticeMultiCustomer) &&
                                filterListMultiCustomerOptions(
                                    props.listOptionsNoticeMultiCustomer
                                )?.map(item => {
                                    return (
                                        <Tooltip
                                            title={item.name}
                                            key={item.value}
                                            value={item.value}
                                            className="select-item"
                                        >
                                            <MenuItem
                                                style={item?.isDisable
                                                    ? { opacity: 0.8, color: '#a9a9a9', cursor: 'default' }
                                                    : undefined
                                                }
                                                key={item.value}
                                                value={item.value}
                                            >
                                                {item.name}
                                            </MenuItem>
                                        </Tooltip>
                                    );
                                })}
                        </TextField>
                    )}
                </div>
            </div>
            <div className="form-addTicket">
                <label className="form-addTicket-label">フォーマット</label>
                <div className="form-addTicket-input" data-cy="qa-ticket-select-form">
                    <TextField
                        className="form-control form-control--wrap form-control--hg40"
                        select
                        variant="outlined"
                        name="selectedForm"
                        required
                        value={props.selectedForm}
                        onChange={e => {
                            handleOnchangeFormNotice(e, props);
                            e.stopPropagation();
                        }}
                        errorlist={props.errorCreateTicket}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        disabled={!Utils.isEmptyString(props.detailTicket?.deletedAt)}
                    >
                        {Utils.isEmptyArray(props.formList) && (
                            <MenuItem style={{ display: 'none' }}></MenuItem>
                        )}

                        {!Utils.isEmptyArray(props.formList) &&
                            props.formList?.map(item => {
                                return (
                                    <MenuItem key={item.id} value={item.id}>
                                        {Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            item.name
                                        )}
                                    </MenuItem>
                                );
                            })}
                    </TextField>
                </div>
            </div>
        </div>
    );
}
